import { RootState } from '@app/store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { api as authApi } from '@app/services/auto-generated/auth'

// const isDarkMode =
//   window.matchMedia &&
//   window.matchMedia("(prefers-color-scheme: dark)").matches;

export type modeType = 'browser' | 'light' | 'dark'

interface themeState {
  mode: modeType
  kids: boolean
}
const initialState: themeState = {
  mode: 'browser',
  kids: false,
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<modeType>) => {
      state.mode = action.payload
    },
  },
})

export const { setThemeMode } = themeSlice.actions

export default themeSlice.reducer

export const selectMode = (state: RootState) => state.theme.mode
